import React from 'react';
const CheckboxGroupArea = ({ register, name, label, required, options, selected, onChange }) => {
  return (
    <div className="mb-4">
    
      <div className="flex flex-col space-y-2">
        {options.map((option) => (
          <label key={option.value} className="flex items-center space-x-2">
            <input
              type="checkbox"
              value={option.value}
              {...register(name, {
                required: required ? `${label} is required!` : false,
              })}
              checked={selected.includes(option.value)}
              onChange={(e) => onChange(e.target.value)}
              className="h-4 w-4"
            />
            <span className='text-sm'>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroupArea;